const invertedMessages = {
  'View More...': 'external.blogs.viewMore',
} as const;

export default invertedMessages;
